module.exports = __webpack_public_path__ + "static/high-output-management-cefff0c8bf904d73b721bf4bc118ac76.jpg";